var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5303 4.4693C15.8232 4.7622 15.8232 5.23707 15.5303 5.52996L9.06066 11.9996L15.5303 18.4693C15.8232 18.7622 15.8232 19.2371 15.5303 19.53C15.2374 19.8229 14.7626 19.8229 14.4697 19.53L7.46967 12.53C7.17678 12.2371 7.17678 11.7622 7.46967 11.4693L14.4697 4.4693C14.7626 4.17641 15.2374 4.17641 15.5303 4.4693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLight);
export default __webpack_public_path__ + "static/media/ArrowLight.cf8a6fa98a57124ab9fe2ae0e1e1b913.svg";
export { ForwardRef as ReactComponent };